export default "__VITE_ASSET__CF7QEnm1__"